import React from "react";
import styles from "./Spinner.module.css";
type Props = {
  className?: any;
  light?: boolean;
  size?: number;
  height?: string;
};

const Spinner = ({
  className,
  light = false,
  size = 7,
  height
}: Props) => <div className={className || styles.container} style={height && {
  height
}}>
    <div className={light ? styles.spinnerLight : styles.spinner} style={{
    fontSize: `${size}px`
  }} />
  </div>;

export default Spinner;